<template>
    <academic>
        <div class="p-6 bg-white border-b border-gray-200 shadow-sm sm:rounded-lg">
            <loading :showLoading="form.processing" />
            <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
                <p class="text-lg font-medium mb-4">Add Course</p>
                <form @submit.prevent="submitForm">
                    <div class="grid grid-cols-8 gap-4 mb-4">
                        <div class="col-span-4 sm:col-span-4">
                            <breeze-label :required="true" :value="'Title'"/>
                            <breeze-input required v-model="form.title" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.title:''" />
                        </div>
                        <div class="col-span-4 sm:col-span-4">
                            <breeze-label :required="true" :value="'Duration'"/>
                            <breeze-input required v-model="form.duration" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.duration:''" />
                        </div>
                        <div class="col-span-4 sm:col-span-4">
                            <breeze-label :required="true" :value="'Level'"/>
                            <breeze-input required v-model="form.level" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.level:''" />
                        </div>
                        <div class="col-span-4 sm:col-span-4">
                            <breeze-label :required="true" :value="'Eligibility'"/>
                            <breeze-input required v-model="form.eligibility" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.eligibility:''" />
                        </div>
                        <div class="col-span-4 sm:col-span-4">
                            <breeze-label :required="true" :value="'Mode'"/>
                            <breeze-input required v-model="form.mode" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.mode:''" />
                        </div>
                        <div class="col-span-4 sm:col-span-4">
                            <breeze-label :required="true" :value="'Code'"/>
                            <breeze-input required v-model="form.code" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.code:''" />
                        </div>
                        <div class="col-span-3 sm:col-span-3">
                            <!-- <breeze-label :value="'Course Type'"/>
                            <select-list required v-model="form.course_type" :options="course_types" :label="['title']" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.course_type:''" /> -->

                            <FormMultiselect
                            required
                            label="Course Type"
                            :options="course_types"
                            track-key="id"
                            label-key="title"
                            :object="true"
                            v-model="form.course_type"
                            :placeholder="'Select Course Type'"
                            :error="form.errors.course_type"
                            />
                        </div>
                        <div class="">
                            <breeze-label :value="'Status'"/>
                            <breeze-checkbox v-model="form.status"/>
                            <breeze-input-error :message="form.errors?form.errors.status:''" />
                        </div>
                    </div>
                    <button-link :href="route('academic.course.list')" class="bg-red-500 mr-4 hover:bg-red-400">Cancel</button-link>
                    <breeze-button :disabled="form.processing">Save</breeze-button>
                    <exception />
                </form>
            </div>
        </div>
    </academic>
</template>

<script>
    import Academic from '@/Pages/Academic/Academic'
    import BreezeTable from '@/Components/Table'
    import BreezeInput from '@/Components/Input'
    import BreezeLabel from '@/Components/Label'
    import BreezeButton from '@/Components/Button'
    import BreezeCheckbox from '@/Components/Checkbox'
    import InputCheckbox from '@/Components/InputCheckbox'
    import BreezeInputError from '@/Components/InputError'
    import ButtonLink from '@/Components/ButtonLink'
    import SelectList from '@/Components/SelectList'
    import Exception from '@/Components/Exception'
    import { useForm } from '@inertiajs/inertia-vue3'
    import Loading from '@/Components/Loading'
    import FormMultiselect from "@/Components/Forms/FormMultiselect.vue";

    export default {
        components: {
            FormMultiselect,
            Academic,
            BreezeTable,
            ButtonLink,
            BreezeInput,
            BreezeCheckbox,
            BreezeLabel,
            BreezeInputError,
            BreezeButton,
            Exception,
            InputCheckbox,
            Loading,
            SelectList
        },
        props:['course_types'],
        data(){
            return{
                form: useForm({
                    title: '',
                    duration: '',
                    level: '',
                    mode: '',
                    eligibility: '',
                    code: '',
                    course_type: '',
                    status: true,
                }),
            }
        },
        methods: {
            submitForm() {
                this.form.post(route('academic.course.store'),{
                    preserveScroll: true,
                    onSuccess: () => this.form.reset(),
                });
            },
        },
    }
</script>
